module.exports = __webpack_public_path__ + "static/assets/4e91dccc5b5e8d4017e35ff6b789b782.svg";